import { connect } from "react-redux";
import get from "lodash/get";

import {
  getCompanyGroups as onGetCompanyGroups,
  selectedGroup as onSelectedGroup,
  addUnitGroup as onAddUnitGroup,
  deleteUnitGroup as onDeleteUnitGroup,
  createGroup as onCreateGroup,
  deleteGroup as onDeleteGroup
} from "../../actions/companyGroupsAction";

const mapStateToProps = (state) => ({
  companyGroupsDataState: state.companyGroups.companyGroupsDataState,
  addUnitGroupDataState: state.companyGroups.addUnitGroupDataState,
  delUnitGroupDataState: state.companyGroups.delUnitGroupDataState,
  createGroupDataState: state.companyGroups.createGroupDataState,
  deleteGroupDataState: state.companyGroups.deleteGroupDataState,
  companyGroups: get(state, ["companyGroups", "companyGroups"], []),
  selectedGroup: get(state, ["companyGroups", "selectedGroup"], null),
});

const mapDispatchToProps = {
  onGetCompanyGroups,
  onSelectedGroup,
  onAddUnitGroup,
  onDeleteUnitGroup,
  onCreateGroup,
  onDeleteGroup,
};

const withCompanyGroups = (Component) => connect(mapStateToProps, mapDispatchToProps)(Component);

export { withCompanyGroups };
